/* import __COLOCATED_TEMPLATE__ from './classes.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class ClassGroupsComponent extends Component
{
	@service store;
	@service errorManager;
	
	@tracked isAddingNew = false;
	
	@tracked newClassName = "";
	@tracked newClassGender = "M";
	
	@action
	async saveNew(browserEvent)
	{
		browserEvent.preventDefault();
		
		const newClass = this.store.createRecord('class',
		{
			name: this.newClassName,
			gender: this.newClassGender,
			EventId: this.args.event,
		});
		try
		{
			await newClass.save();
			await this.store.findRecord('class',newClass.id);
		}
		catch (error)
		{
			// Error is displayed by the adapter
			newClass.rollbackAttributes();
			return;
		}
		
		this.newClassName = "";
		this.newClassGender = "M";
		this.isAddingNew = false;
	};
	
	@action
	cancelNew()
	{
		this.newClassName = "";
		this.newClassGender = "M";
		this.isAddingNew = false;
	};
	
	@action
	genderSelectionChangedNew(browserEvent)
	{		
		this.newClassGender = browserEvent.target.value;
	};
	
	@action
	genderSelectionChangedEdit(eventClass, browserEvent)
	{		
		eventClass.gender = browserEvent.target.value;
	};
	
	@action
	async classGroupSelectionChanged(eventClass, browserEvent)
	{		
		var classGroup = browserEvent.target.value;
		
		const existingClassGroup = eventClass.ClassGroupId.content;
		
		if(classGroup == '-')
		{
			eventClass.ClassGroupId = null;
		}
		else
		{
			let foundClassGroup = this.store.peekRecord('classGroup', classGroup);
			eventClass.ClassGroupId = foundClassGroup;
		}
		
		try
		{
			await eventClass.save();
		}
		catch (error)
		{
			// Error is displayed by the adapter
			eventClass.ClassGroupId = existingClassGroup;
		}
	};
	
	@action
	async deleteClass(eventClass)
	{
		const entries = await eventClass.get('entries');

		if(entries.length > 0)
		{
			this.errorManager.addError("Class has entries assigned. Cannot be deleted.", { clearable: true, type: 'validation' });
			return;
		}

		eventClass.deleteRecord();

		try
		{
			await eventClass.save();
		}
		catch (error)
		{
			// Error is displayed by the adapter
			eventClass.rollbackAttributes();
		}
	};
}